module.exports = __webpack_public_path__ + "static/media/banner.e330d5b7.png";